// extracted by mini-css-extract-plugin
module.exports = {"scroll":"VotingList_scroll__5HeGD","scroll_cell":"VotingList_scroll_cell__3ZPSr"};